import { Tooltip } from "@nextui-org/react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../shared/services/store/useAuth";
import { useSidebar } from "./SidebarContext";


export default function Sidebar() {
    const { isMobileOpen, setIsMobileOpen, isMobile, isDesktopCollapsed, setIsDesktopCollapsed } = useSidebar();
    
    const { logout, userdetails } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/');
        setIsMobileOpen(false);
    };

    const getDisplayLetter = () => {
        if (userdetails?.Role === 'Admin' || userdetails?.Role === 'Student') {
            return userdetails.Username?.charAt(0).toUpperCase();
        } else {
            return userdetails?.First_Name?.charAt(0).toUpperCase();
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>
            <div className="sticky inset-x-0 top-0 z-20 px-4 bg-white border-y sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center justify-between py-2">
                    <div className="flex items-center gap-3">
                       {isDesktopCollapsed === false ?  (
                            <Link to={"/"}>
                                <img src="/images/logo/favicon.png" className="h-12 rounded-xl" alt="Kavins Logo" />
                            </Link>
                       ) : (
                             <Link to={"/"}>
                                <img src="/images/logo/KAVINS ACADEMY logo.png" className="h-10 rounded-xl" alt="Kavins Logo" />
                            </Link>
                       )}
                    </div>
                    <div className="flex gap-2">
                        <button type="button" 
                            className="flex items-center justify-center gap-x-1.5 px-3 py-2 text-gray-500 transition-colors border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-gray-600"
                            onClick={() => setIsMobileOpen(!isMobileOpen)}
                        >
                            <svg className="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M17 8L21 12L17 16M3 12H13M3 6H13M3 18H13"/>
                            </svg>
                            <span className="sr-only">Toggle Sidebar</span>
                        </button>
                        <div className="hs-dropdown [--placement:bottom-left] relative inline-flex">
                            <button type="button"
                                className="w-[2.375rem] h-[2.375rem] inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100"
                            >
                                {userdetails ? (
                                    <div className="inline-flex items-center justify-center w-[38px] h-[38px] rounded-full bg-regal-blue ring-2 ring-white">
                                        <span className="text-lg font-bold text-white">
                                            {getDisplayLetter()}
                                        </span>
                                    </div>
                                ) : (
                                    <div className="inline-flex items-center justify-center w-[38px] h-[38px] rounded-full bg-gray-100 ring-2 ring-white">
                                        <i className="text-xl text-gray-500 fi fi-rr-user"></i>
                                    </div>
                                )}
                            </button>

                            <div className="hs-dropdown-menu transition-[opacity,margin] z-50 pt-10 duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-60 bg-white shadow-md rounded-lg p-2" aria-labelledby="hs-dropdown-with-header">
                                <div className="px-5 py-3 -m-2 rounded-t-lg bg-secondary">
                                    <p className="text-sm text-white">Signed in as {userdetails?.First_Name}</p>
                                    <p className="mt-3 text-sm font-medium text-white">{userdetails?.Email}</p>
                                </div>
                                <div className="py-2 mt-2 first:pt-0 last:pb-0">
                                    {userdetails ? (
                                        <>
                                            {userdetails?.Role === "Admin" && (
                                                <Link to="/dashboard/home" className="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 cursor-pointer">
                                                    <i className="fi fi-rr-dashboard-panel"></i>
                                                    Admin Dashboard
                                                </Link>
                                            )}
                                            {userdetails?.Role === "Student" && (
                                                <Link to="/dashboard/studenthome" className="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 cursor-pointer">
                                                    <i className="fi fi-rr-dashboard-panel"></i>
                                                    My Dashboard
                                                </Link>
                                            )}
                                            {userdetails?.Role === "Customer" && (
                                                <>
                                                    <Link to="/myaccount" className="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500">
                                                        <i className="mt-1 font-semibold fi fi-rr-portrait"></i>
                                                        My Account
                                                    </Link>
                                                    <Link to="/myorder" className="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500">
                                                        <i className="mt-1 fi fi-br-order-history"></i>
                                                        My Order
                                                    </Link>
                                                </>
                                            )}
                                            <Link onClick={handleLogout} className="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 cursor-pointer">
                                                <i className="mt-1 fi fi-br-sign-out-alt"></i>
                                                Logout
                                            </Link>
                                        </>
                                    ) : (
                                        <Link to="/login" className="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500">
                                            <i className="mt-1 fi fi-br-sign-in-alt"></i>
                                            Login
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isMobile && isMobileOpen && (<div className="fixed inset-0 z-[50] bg-black bg-opacity-50 transition-opacity lg:hidden" onClick={() => setIsMobileOpen(false)} />)}

            <div className={`fixed inset-y-0 start-0 z-[60] bg-[#1a1f37] shadow-xl border-r border-gray-800/10 transition-all duration-300 transform
                ${isMobile ? isMobileOpen ? 'translate-x-0 w-64' : '-translate-x-full' : isDesktopCollapsed ? 'w-20' : 'w-64'}
                ${isMobile ? 'lg:translate-x-0' : ''}
            `}>
                {!isMobile && (
                    <button onClick={() => setIsDesktopCollapsed(!isDesktopCollapsed)}
                        className="absolute right-0 top-6 translate-x-1/2 bg-[#F5C231] hover:bg-[#f5a531] text-black p-2 rounded-full shadow-lg transition-all duration-300 z-10"
                    >
                        <svg className={`w-4 h-4 transition-transform duration-300 ${isDesktopCollapsed ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                )}

                <div className="flex flex-col items-center justify-center px-2 pt-6 pb-8">
                    { isDesktopCollapsed === true ?
                        <Link to={"/"} className="p-1 bg-white shadow-lg rounded-xl backdrop-blur-sm">
                            <img src="/images/logo/favicon.png" className="w-10 transition-all duration-300 rounded-xl"   alt="Kavins Logo" />
                        </Link>
                        :
                        <Link to={"/"} className="p-2 bg-white shadow-lg rounded-xl backdrop-blur-sm">
                            <img src="/images/logo/KAVINS ACADEMY logo.png" className={`transition-all duration-300 rounded-xl ${isDesktopCollapsed && !isMobile ? 'h-[30px]' : 'h-[40px]'}`}alt="Kavins Logo" />
                        </Link>
                    }
                </div>

                <nav className="flex flex-col flex-wrap w-full py-4">
                    <ul className="space-y-1.5 px-3">
                        <li className="block mb-3 lg:hidden">
                            <Link onClick={() => {scrollToTop();setIsMobileOpen(false)}}
                                className="flex items-center justify-center w-full px-4 py-3 text-sm font-bold text-center text-white transition-all duration-300 ease-in-out rounded-lg bg-gradient-to-r from-[#F5C231] to-[#f5a531] hover:shadow-lg hover:shadow-[#F5C231]/30" 
                                to="/application-form"
                            >
                                <i className="mr-2 text-lg fi fi-rr-edit"></i>
                                Apply Now
                            </Link>
                        </li>
                        <NavItem icon="fi fi-rr-house-chimney" label="Home" to="/" onClick={() => setIsMobileOpen(false)} isCollapsed={isDesktopCollapsed && !isMobile} />
                        <NavItem icon="fi fi-rr-info" label="About Us" to="/aboutus" onClick={() => setIsMobileOpen(false)} isCollapsed={isDesktopCollapsed && !isMobile} />
                        <NavItem icon="fi fi-rr-gallery" label="Gallery" to="/gallery" onClick={() => setIsMobileOpen(false)} isCollapsed={isDesktopCollapsed && !isMobile} />
                        <NavItem icon="fi fi-ss-book-open-cover" label="Shop" to="/study-materials" onClick={() => setIsMobileOpen(false)} isCollapsed={isDesktopCollapsed && !isMobile} />
                        <NavItem icon="fi-rr-apps" label="Current Affairs" to="/current-affairs" onClick={() => setIsMobileOpen(false)} isCollapsed={isDesktopCollapsed && !isMobile} />
                        <NavItem icon="fi fi-sr-quiz-alt" label="Test Series" to="/online-test-series" sectionRoutes={['/test-result']} onClick={() => setIsMobileOpen(false)} isCollapsed={isDesktopCollapsed && !isMobile} />
                        <NavItem icon="fi fi-sr-document" label="PYQ's" to="/previous-year-papers" sectionRoutes={['/previous-year-papers', '/pyq-details', '/pyq-papers']} onClick={() => setIsMobileOpen(false)} isCollapsed={isDesktopCollapsed && !isMobile} />
                    </ul>
                </nav>
            </div>
        </>
    )
}

const NavItem = ({ icon, label, to, sectionRoutes = [], onClick, isCollapsed }) => {
    const location = useLocation();
    
    const isInSection = sectionRoutes.length > 0 ? sectionRoutes.some(route => location.pathname.startsWith(route)) : location.pathname === to;
    
    return (
        <li>
            <Tooltip content={label} placement="right" isDisabled={!isCollapsed}>
                <NavLink to={to} onClick={onClick}
                    className={({ isActive }) => {
                        const shouldBeActive = isActive || isInSection;
                        return `flex items-center gap-3 py-3 rounded-xl transition-all duration-200
                            ${isCollapsed ? 'justify-center px-2' : 'w-full px-4'}
                            ${shouldBeActive ? 'bg-gradient-to-r from-[#F5C231] to-[#f5a531] text-black shadow-lg shadow-[#F5C231]/20' : 'text-gray-200 hover:text-white hover:bg-white/10'}
                        `;
                    }}
                >
                    <i className={`text-xl ${icon} flex-shrink-0`}></i>
                    {!isCollapsed && <span className="text-sm font-medium whitespace-nowrap">{label}</span>}
                </NavLink>
            </Tooltip>
        </li>
    );
};